export const FETCH_SIDEBAR_DETAILS = "FETCH_SIDEBAR_DETAILS";
export const RESET_SIDEBAR_DETAILS = "RESET_SIDEBAR_DETAILS";
